import { Store } from '@campaign/domain/store';
import { createLogger } from '@campaign/utils/logger';
import { onloadCampaigns } from './user';

const logger = createLogger('@domain/middlewares/loadPublicData');

/**
 * Load public data campaigns
 *
 * @param store Store
 * @param isLoggedIn Whether the user is logged in
 */
export async function loadPublicCampaigns(
  store: Store,
  isLoggedIn: boolean
): Promise<void> {
  try {
    await onloadCampaigns(store, isLoggedIn);
  } catch (error) {
    logger.error(
      '[loadPublicCampaigns] Failed to load public campaigns',
      error
    );
  }
}
